import React from 'react'

const MosaicLimitations = () => (
  <div className='br-upload-limitations'>
    <h4>MASTER PHOTO MOSAIC GUIDELINES:</h4>
    <div>
      <ul>
        <li>
          <strong>Dimensions: </strong>Photo mosaic must be 750 x 1334 pixels.
        </li>
        <li>
          <strong>Aspect ratio: </strong>Must have an aspect ration of 1:1.75 to
          ensure it's compatible with mobile devices
        </li>
      </ul>
    </div>
  </div>
)
export default MosaicLimitations



// WEBPACK FOOTER //
// ./src/pages/widgets/form/media-upload/limitations/mosaic.js